import { makeAutoObservable } from "mobx";
import CommonUtil from "utils/CommonUtil";
import TbSysPop from "domain/main/sys/pop/TbSysPop";

const mainPopupRepository = new (class MainPopupRepository {
    constructor() {
        makeAutoObservable(this);
    }

    /**
     * 조회
     */
    public async get(): Promise<TbSysPop[]> {
        const result = await CommonUtil.execute({
            url:"usr_popup"
        })
            .then((response:any) => {
                return response.POP_LIST || [];
            })
        return result.map(item => new TbSysPop(JSON.parse(item))) || []
    }
})();

export default mainPopupRepository;
